import { render, staticRenderFns } from "./trigonScore.vue?vue&type=template&id=8eee12de&scoped=true&"
import script from "./trigonScore.vue?vue&type=script&lang=js&"
export * from "./trigonScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eee12de",
  null
  
)

export default component.exports